import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SidePanelHaveAnAccountLink = ({
  href,
  accountLinkMessage = 'button.haveAnAccountLink',
  onClick = () => {}
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    blockSize: "24px",
    alignItems: "center",
    gap: "100",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: accountLinkMessage
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "link-100",
      children: /*#__PURE__*/_jsx(Link, {
        href: href,
        onClick: onClick,
        "data-selenium": "signin-link",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: 'button.signIn'
        })
      })
    })]
  });
};